import { smoothScrollIntoView } from '@cian/valuation-utils-component';
import * as React from 'react';

import { AboutReportDesktop } from '../../components/AboutReportDesktop';
import { HowItWorks } from '../../components/HowItWorks';
import { OurNumbers } from '../../components/OurNumbers';
import { Questions } from '../../components/Questions';
import { useToggleStickyScrollBtn } from '../../utils/useToggleStickyScrollBtn';
import { InfoCardContainer } from '../InfoCardContainer';
import { PrevEstimationsContainer } from '../PrevEstimationsContainer';
import { StickyScrollBtnContainer } from '../StickyScrollBtnContainer';
import { ValuationFiltersDesktopContainer } from '../ValuationFiltersContainer';

export const DesktopViewContainer = () => {
  const buttonRef = React.useRef<HTMLDivElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(buttonRef);

  const scrollToFilters = React.useCallback(() => {
    smoothScrollIntoView(containerRef.current as HTMLElement);
  }, []);

  return (
    <>
      <ValuationFiltersDesktopContainer buttonRef={buttonRef} containerRef={containerRef} />
      <Questions>
        <PrevEstimationsContainer textColor="black_100" />
        <InfoCardContainer />
        <AboutReportDesktop />
        <OurNumbers />
        <HowItWorks />
      </Questions>
      <StickyScrollBtnContainer scrollToFilters={scrollToFilters} />
    </>
  );
};
